import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  Container,
} from '@chakra-ui/react';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import ProfileForm from './ProfileForm';
import PreferenceForm from './PreferenceForm';
import AccountForm from './AccountForm';
import TutorSelectionForm from './TutorSelectionForm';

const SettingsPage = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);
  const [profiles, setProfiles] = useState({});
  const [preferences, setPreferences] = useState({});
  const [tutor, setTutor] = useState("");
  const [plan, setPlan] = useState({});

  useEffect(() => {
    const fetchUserSettings = async () => {
      try {
        const { data } = await api.get(`${API_BASE}/api/user/profile-preferences`);
        // console.log('user settings data: ', data);
        setProfiles(data?.profile);
        setPreferences(data?.preferences || {});
        setPlan(data?.userPlan);
        setTutor(data?.tutor);
        // if (data.data?.avatarUrl) setAvatar(data.data?.avatarUrl);
      } catch (error) {
        console.error('Failed to load user settings:', error);
      }
    };
    fetchUserSettings();
  }, []);

  useEffect(() => {
    // Parse the query parameter to set the active tab
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');

    if (tab === 'account') {
      setActiveTab(1);
    } else if (tab === 'preferences') {
      setActiveTab(2);
    } else if (tab == 'tutor') {
      setActiveTab(3);
    } else {
      setActiveTab(0); // Default to 'profile' tab
    }
  }, [location.search]);

  return (
    <Container maxW={{ base: '100%', md: '80%', lg: '50%' }} mt={20}>
      <Heading size="md" fontWeight="bold">
        My Profile and Settings
      </Heading>
      <Box p={4}>
        <Tabs
          variant="line"
          colorScheme="green"
          index={activeTab}
          onChange={(index) => setActiveTab(index)}
        >
          <TabList>
            <Tab fontWeight="bold">Profile</Tab>
            <Tab fontWeight="bold">Account</Tab>
            <Tab fontWeight="bold">Preferences</Tab>
            <Tab fontWeight="bold">Tutor</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <ProfileForm profiles={profiles} />
            </TabPanel>
            <TabPanel>
              <AccountForm plan={plan} />
            </TabPanel>
            <TabPanel>
              <PreferenceForm preferences={preferences} />
            </TabPanel>
            <TabPanel><TutorSelectionForm tutorId={tutor} /></TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Container>
  );
};

export default SettingsPage;
